// src/app/firebase/firebase.service.ts
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging'; // Correct imports from @angular/fire/messaging
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';
import { NotificationService } from '../dataServices/notification-service';
import { SessionService } from '../other/session';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private messaging = inject(Messaging);
  currentMessage = new BehaviorSubject<any>(null); // Use <any> for payload type
  dataService = inject(NotificationService);
  sessionService = inject(SessionService);
  readonly count: WritableSignal<number> = signal(0);

  constructor() {
    this.listen(); // Start listening for messages immediately
  }

  async requestPermission() {
    if (!('Notification' in window)) {
      console.warn("This browser does not support notifications.");
      return;
    }

    try {
      // getToken correctly uses the injected `this.messaging` instance
      const token = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapidKey,
      });

      if (token) {
        console.log('FCM device token generated:', token);
        const data = {
          fcmToken: token
        }
        this.sendFCMTokenToBackEnd(data).subscribe({
          next: (res: any) => {
            console.log('FCM token sent to backend successfully:', res);
            if (res?.sessionToken) {
              this.sessionService.saveSession(res, res.sessionToken);
            }
          },
          error: (err) => {
            console.error('Failed to send FCM token to backend:', err);
          }
        });
      } else {
        console.log('No FCM device token available. Notification permission not granted or denied.');
      }
    } catch (err) {
      console.error('Permission denied or error during token request:', err);
      if ((err as any).code === 'messaging/permission-blocked') {
        alert("Notifications are blocked by the user. Please unblock them in browser settings.");
      }
    }
  }

  listen() {
    // onMessage correctly uses the injected `this.messaging` instance
    onMessage(this.messaging, (payload) => {
      console.log('Foreground message received: ', payload);
      this.currentMessage.next(payload);
      this.count.update(c => c + 1);
    });
  }

  sendFCMTokenToBackEnd(tokenData: { fcmToken : string }): Observable<any>{
    return this.dataService.saveFcmToken(tokenData);
  }
}
